import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4c680a99"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "manifold nft-promo-note m-token-exclusive-warning" }
const _hoisted_2 = { class: "icon-container" }
const _hoisted_3 = ["src"]
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "promo-info" }
const _hoisted_6 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.customStarImage)
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            src: _ctx.customStarImage
          }, null, 8, _hoisted_3))
        : (_openBlock(), _createElementBlock("img", {
            key: 1,
            src: _ctx.starFavorite
          }, null, 8, _hoisted_4))
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createElementVNode("span", null, _toDisplayString(_ctx.eligibleTokensTitle), 1),
      _createElementVNode("span", null, [
        _createTextVNode(_toDisplayString(_ctx.eligibleTokensMessage) + " ", 1),
        _createElementVNode("a", {
          href: _ctx.link,
          target: "_blank"
        }, _toDisplayString(`${_ctx.linkText}${
              _ctx.state && _ctx.state.campaign && _ctx.state.campaign.snapshot ? ' for the next drop' : ''
            }`), 9, _hoisted_6)
      ])
    ])
  ]))
}